import React, { useEffect } from "react";

export default function PricingPage() {
  useEffect(() => {
    const style = document.createElement("style");

    style.innerHTML = `
      * {
        box-sizing: border-box;
        margin: 0;
        padding: 0;
      }

      .pricing-page {
        min-height: 100vh;
        background: #060606;
        color: #fff;
        font-family: Inter, -apple-system, BlinkMacSystemFont,
          "Segoe UI", sans-serif;
        padding: 80px 20px;
        position: relative;
        overflow: hidden;
      }

      .glow {
        position: absolute;
        border-radius: 50%;
        filter: blur(140px);
        opacity: .35;
      }

      .glow1 {
        width: 500px;
        height: 500px;
        background: #2563eb;
        top: -150px;
        left: -100px;
      }

      .glow2 {
        width: 450px;
        height: 450px;
        background: #8b5cf6;
        bottom: -150px;
        right: -100px;
      }

      .hero {
        max-width: 900px;
        margin: auto;
        text-align: center;
        margin-bottom: 90px;
      }

      .badge {
        display: inline-block;
        padding: 10px 20px;
        border-radius: 999px;
        background: rgba(255,255,255,.06);
        border: 1px solid rgba(255,255,255,.12);
        backdrop-filter: blur(20px);
        margin-bottom: 30px;
      }

      .hero h1 {
        font-size: clamp(3rem, 8vw, 5.5rem);
        line-height: 1.05;
        font-weight: 800;
        margin-bottom: 25px;
      }

      .hero h1 span {
        background: linear-gradient(
          90deg,
          #fff,
          #60a5fa,
          #8b5cf6
        );
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }

      .hero p {
        color: #b5b5b5;
        font-size: 1.2rem;
        max-width: 700px;
        margin: auto;
      }

      .pricing-grid {
        max-width: 1300px;
        margin: auto;
        display: grid;
        grid-template-columns:
          repeat(auto-fit, minmax(380px, 1fr));
        gap: 40px;
      }

      .card {
        background: rgba(255,255,255,.05);
        border: 1px solid rgba(255,255,255,.08);
        backdrop-filter: blur(30px);
        border-radius: 35px;
        padding: 45px;
        position: relative;
        transition: all .35s ease;
      }

      .card:hover {
        transform: translateY(-12px);
        box-shadow:
          0 30px 60px rgba(0,0,0,.45);
      }

      .featured {
        border: 1px solid rgba(96,165,250,.45);
        box-shadow:
          0 0 60px rgba(96,165,250,.15);
      }

      .label {
        position: absolute;
        top: 25px;
        right: 25px;
        background: linear-gradient(
          90deg,
          #2563eb,
          #8b5cf6
        );
        padding: 8px 16px;
        border-radius: 999px;
        font-size: .85rem;
        font-weight: 600;
      }

      .card h2 {
        font-size: 2rem;
        margin-bottom: 20px;
      }

      .price {
        font-size: 4rem;
        font-weight: 800;
        margin-bottom: 10px;
      }

      .price small {
        font-size: 1.5rem;
      }

      .subtitle {
        color: #b5b5b5;
        margin-bottom: 30px;
      }

      ul {
        list-style: none;
        margin-top: 30px;
      }

      li {
        padding: 10px 0;
        color: #d7d7d7;
      }

      .payments {
        margin-top: 30px;
      }

      .payments div {
        display: flex;
        justify-content: space-between;
        padding: 15px 0;
        border-bottom:
          1px solid rgba(255,255,255,.08);
      }

      button {
        width: 100%;
        margin-top: 35px;
        padding: 18px;
        border: none;
        border-radius: 18px;
        background: linear-gradient(
          90deg,
          #2563eb,
          #8b5cf6
        );
        color: #fff;
        font-size: 1rem;
        font-weight: 700;
        cursor: pointer;
        transition: .3s;
      }

      button:hover {
        transform: scale(1.03);
      }

      .features {
        max-width: 1300px;
        margin: 120px auto 0;
      }

      .features h2 {
        text-align: center;
        font-size: 3rem;
        margin-bottom: 50px;
      }

      .feature-grid {
        display: grid;
        grid-template-columns:
          repeat(auto-fit, minmax(250px, 1fr));
        gap: 30px;
      }

      .feature {
        background: rgba(255,255,255,.05);
        border: 1px solid rgba(255,255,255,.08);
        backdrop-filter: blur(25px);
        border-radius: 30px;
        padding: 35px;
        transition: .3s;
      }

      .feature:hover {
        transform: translateY(-8px);
      }

      .feature h3 {
        margin-bottom: 15px;
      }

      .feature p {
        color: #b5b5b5;
        line-height: 1.6;
      }

      @media (max-width: 768px) {
        .card {
          padding: 35px 25px;
        }

        .price {
          font-size: 3rem;
        }

        .hero p {
          font-size: 1rem;
        }
      }
    `;

    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style);
    };
  }, []);

  return (
    <div className="pricing-page">
      <div className="glow glow1"></div>
      <div className="glow glow2"></div>

      <section className="hero">
        <div className="badge">
          Custom eCommerce Solutions
        </div>

        <h1>
          Launch your online store
          <br />
          <span>for £1,999</span>
        </h1>

        <p>
          Professionally built eCommerce websites
          with full source code ownership after
          final payment.
        </p>
      </section>

      <div className="pricing-grid">
        <div className="card">
          <div className="label">Save 5%</div>

          <h2>Pay in Full</h2>

          <div className="price">
            £1,899<small>.05</small>
          </div>

          <p className="subtitle">
            One payment. Save £99.95 instantly.
          </p>

          <ul>
            <li>✓ Priority project start</li>
            <li>✓ No future instalments</li>
            <li>✓ Full source code ownership</li>
            <li>✓ Admin dashboard included</li>
            <li>✓ Stripe payments included</li>
          </ul>

          <button>
            Pay in Full
          </button>
        </div>

        <div className="card featured">
          <div className="label">
            Most Popular
          </div>

          <h2>Flexible Payments</h2>

          <div className="price">
            £1,999
          </div>

          <p className="subtitle">
            Start today with only £99.99.
          </p>

          <div className="payments">
            <div>
              <span>Deposit</span>
              <strong>£99.99</strong>
            </div>

            <div>
              <span>Installation</span>
              <strong>£400.00</strong>
            </div>

            <div>
              <span>Month 1</span>
              <strong>£500.00</strong>
            </div>

            <div>
              <span>Month 2</span>
              <strong>£500.00</strong>
            </div>

            <div>
              <span>Month 3</span>
              <strong>£499.01</strong>
            </div>
          </div>

          <button>
            Start with £99.99
          </button>
        </div>
      </div>

      <section className="features">
        <h2>What's Included</h2>

        <div className="feature-grid">
          <div className="feature">
            <h3>Admin Dashboard</h3>
            <p>
              Products, orders, customers
              and sales management.
            </p>
          </div>

          <div className="feature">
            <h3>Stripe Payments</h3>
            <p>
              Secure payment processing
              built into your store.
            </p>
          </div>

          <div className="feature">
            <h3>Responsive Design</h3>
            <p>
              Optimised for desktop,
              tablet and mobile.
            </p>
          </div>

          <div className="feature">
            <h3>Full Ownership</h3>
            <p>
              Receive the complete source
              code after final payment.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}